import orderApi from "api/order/OrderApi";
import OrderActions from "components/OrderDetail/OrderAction";
import OrderHeader from "components/OrderDetail/OrderHeader";
import OrderInfo from "components/OrderDetail/OrderInfo";
import OrderProducts from "components/OrderDetail/OrderProducts";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Loading from "Util/Loading";
import TrackingModal from "components/OrderDetail/TrackModal";
import RestaurantInfo from "components/OrderDetail/RestaurantInfo";
import Billing from "components/OrderDetail/Billing";

const OrderDetailPage = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [isTrackingOpen, setIsTrackingOpen] = useState(false);
  /* ================= FETCH ================= */
  const fetchOrder = async () => {
    try {
      const { response } = await orderApi.getOrderById(id);
      setOrder(response?.data?.order);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load order");
    }
  };

  useEffect(() => {
    if (id) fetchOrder();
  }, [id]);

  const refreshDataFast = async () => {
    await fetchOrder();
  };

  // Auto refresh for hold times (every 1 minute)
  useEffect(() => {
    console.log("♻️ Auto-refresh: hold times every 1 minute");

    const interval = setInterval(
      () => {
        refreshDataFast();
      },
      1 * 60 * 1000,
    ); // 0.5 minute

    return () => clearInterval(interval);
  }, []);

  console.log({ order });

  if (!order) return <Loading />;

  /* ================= STATUS ================= */

  const getOrderStatus = (order) => {
    if (!order) return "pending";

    if (order.orderStatus === "cancelled") return "cancelled";
    if (order.orderStatus === "completed") return "completed";

    const now = new Date();
    const created = new Date(order.createdAt);
    const hours = (now - created) / (1000 * 60 * 60);

    if (hours > 24) return "completed";

    return order.orderStatus || "pending";
  };

  const orderStatus = getOrderStatus(order);
  const paymentStatus = order?.payments?.paymentStatus || "pending";

  /* ================= ACTIONS ================= */

  const handleCancel = async (id) => {
    try {
      await orderApi.updateOrderStatus({
        id,
        orderStatus: "cancelled",
      });

      toast.success("Order cancelled");
      fetchOrder();
    } catch (err) {
      toast.error("Failed to cancel order");
    }
  };

  const handleReorder = async (order) => {
    try {
      await orderApi.updateOrderStatus({
        id: order._id,
        orderStatus: "pending",
        paymentStatus: "pending",
      });

      toast.success("Order reactivated");

      // ✅ refresh WITHOUT reload
      fetchOrder();
    } catch (err) {
      toast.error("Failed to reorder");
      console.error(err);
    }
  };

  /* ================= UI ================= */

  return (
    <div className="max-w-6xl mx-auto p-2 lg:p-6 space-y-6">
      <OrderHeader order={order} />

      <OrderInfo
        order={order}
        orderStatus={orderStatus}
        paymentStatus={paymentStatus}
        onTrack={() => setIsTrackingOpen(true)}
      />

      <RestaurantInfo order={order} />

      <OrderProducts order={order} />

      <Billing order={order} />

      <OrderActions
        order={order}
        orderStatus={orderStatus}
        onCancel={handleCancel}
        onReorder={handleReorder}
      />

      <TrackingModal
        isOpen={isTrackingOpen}
        onClose={() => setIsTrackingOpen(false)}
        order={order}
      />
    </div>
  );
};

export default OrderDetailPage;
